import styles from "./LandingPage.module.css";
import LandingPageImage from "../../assets/LandingPageImageV4.png";

interface Props {
    sidebarExpanded: boolean;
}

const LandingPage = ({sidebarExpanded}: Props) => {
    return (
        <div className={`${styles.landingPageContainer} ${sidebarExpanded ? styles.expanded : ""}`}>
            <span className={styles.header}>Welcome to the Requirements Elicitation Agent!</span>
            <p className={styles.subtitle}>Effortlessly transform your meeting notes and transcripts into actionable plans with our intelligent agent.</p>
            <div className={styles.landingPageImageContainer}>
                <img src={LandingPageImage} alt="6 Stages illustrated" width="95%" />
            </div>
        </div>
    );
};

export default LandingPage;
